module.exports = __webpack_public_path__ + "img/legend-low-alert.8393cd74.svg";